import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useIsIntersecting } from 'crm-events-components/internal/observers/hooks/useIsIntersecting';
import { Flex } from 'foundations-components/components/Flex';
import { getTimelineScrollContainer } from '../../helpers/getTimelineScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TimelineLoadingObserver({
  isFetching,
  shouldUseThreadedEmailFetchingLogic,
  showMore
}) {
  const scrollTargetRef = useRef(null);
  useEffect(() => {
    scrollTargetRef.current = getTimelineScrollContainer();
  }, []);
  const [targetElement, setTargetElement] = useState();
  const handleTargetRef = useCallback(element => {
    setTargetElement(element);
  }, []);
  const {
    isIntersecting
  } = useIsIntersecting({
    target: targetElement,
    observerOptions: {
      root: scrollTargetRef.current,
      rootMargin: '80%'
    }
  });
  const isFetchingRef = useRef(isFetching);
  useEffect(() => {
    isFetchingRef.current = isFetching;
  }, [isFetching]);

  // used to fetch normally, when emails are not being threaded
  useEffect(() => {
    if (!shouldUseThreadedEmailFetchingLogic && isIntersecting && !isFetchingRef.current) {
      showMore();
    }
  }, [isIntersecting, showMore, shouldUseThreadedEmailFetchingLogic]);

  // used to fetch when emails are being threaded
  useEffect(() => {
    if (shouldUseThreadedEmailFetchingLogic && isIntersecting && !isFetching) {
      showMore();
    }
  }, [isFetching, isIntersecting, showMore, shouldUseThreadedEmailFetchingLogic]);
  const renderedVirtualizedLoadingSpinner = useMemo(() => {
    return isIntersecting ? /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      paddingBlockStart: "200",
      paddingBlockEnd: "600",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    }) : /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true"
    });
  }, [isIntersecting]);
  return /*#__PURE__*/_jsx("div", {
    ref: handleTargetRef,
    "data-test-id": "timeline-loading-spinner",
    children: renderedVirtualizedLoadingSpinner
  });
}
TimelineLoadingObserver.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  shouldUseThreadedEmailFetchingLogic: PropTypes.bool.isRequired,
  showMore: PropTypes.func.isRequired
};